import '@mindtwo/px-user-widgets';
import _ from 'trix';

// Import is important to make sure the px-user-widgets are available
export default defineNuxtPlugin(() => {});
